import { render, staticRenderFns } from "./RegistroAnfitrion.vue?vue&type=template&id=e2475dd2&scoped=true&"
import script from "./RegistroAnfitrion.vue?vue&type=script&lang=js&"
export * from "./RegistroAnfitrion.vue?vue&type=script&lang=js&"
import style0 from "./RegistroAnfitrion.vue?vue&type=style&index=0&id=e2475dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2475dd2",
  null
  
)

export default component.exports